<template>
  <div class="quote-checkout">
    <div class="switchQuote" v-if="paymentPlanSwitch">
      <div class="switchQuote__container" >
        <input
          v-model="selectedPaymentPlan"
          :value="paymentPlans[0]"
          :disabled="totalPriceLoading"
          type="radio"
          id="Annual"
          name="paymentD"
          >
        <label for="Annual">
          <p>{{$t('qic_quote_payment_annual')}}</p>
          <p v-if="prices.annual && !totalPriceLoading">{{$t('qic_qar')}} {{ prices.annual | splitNumber }}</p>
        </label>
      </div>
      <div class="switchQuote__container">
        <input
          v-model="selectedPaymentPlan"
          :value="paymentPlans[1]"
          :disabled="totalPriceLoading"
          type="radio"
          id="Monthly"
          name="paymentD"
          >
        <label for="Monthly">
          <p>{{$t('qic_quote_payment_monthly')}}</p>
          <p v-if="prices.monthly && !totalPriceLoading">{{$t('qic_qar')}} {{ prices.monthly | splitNumber }}</p>
        </label>
      </div>
    </div>
    <div class="quote__promocode" v-if="promocode">
      <span>{{$t('qic_quote_active_promocode')}}</span>
      <span>{{ promocode }}</span>
    </div>
    <ul class="quote-checkout-list">
      <li>
        <span class="name">{{ yourQuoteTitle_ }}</span>
        <span class="price">{{$t('qic_qar')}} {{ getFixedPrice(quoteInclusivePrice) | splitNumber }}</span>
      </li>
      <li v-if="quoteAdditionalPrice">
        <span class="name">{{$t('qic_quote_checkout_additional')}}</span>
        <span class="price">{{$t('qic_qar')}} {{ getFixedPrice(quoteAdditionalPrice) | splitNumber }}</span>
      </li>
      <!-- discount -->
      <template v-if="discountsArrayFiltered && discountsArrayFiltered.length > 1">
        <li class="quote__discount-title"> <span class="name"> {{$t('qic_prequote_online_discount')}} </span> </li>
        <li class="discount" v-for="(discount, index) of discountsArrayFiltered" :key="index">
          <span class="name">{{ discount.name }}</span>
          <span class="price">-{{$t('qic_qar')}} {{ getFixedPrice(discount.premium) | splitNumber }}</span>
        </li>
      </template>
      <template v-else-if="oneDiscount">
        <li class="quote__discount-title"> <span class="name"> {{$t('qic_prequote_online_discount')}} </span> </li>
        <li class="discount">
          <span class="name">{{ getDiscountTitle }}</span>
          <span class="price">-{{$t('qic_qar')}} {{ getFixedPrice(quoteDiscountOnline || discountsArrayFiltered[0].premium) | splitNumber }}</span>
        </li>
      </template>
      <slot name="anyDiscounts"></slot>
      <!-- total -->
      <li class="total">
        <span class="name">{{ priceTitle }}</span>
        <span class="price">
            <Loader v-if="totalPriceLoading" />
            <template v-else>
              {{$t('qic_qar')}} {{ getFixedPrice(quoteTotalPrice) | splitNumber }}
            </template>
          </span>
      </li>
      <div class="quote__monthly-desc" v-if="selectedPaymentPlan === paymentPlans[1]">
        {{$t('qic_quote_payment_monthly_desc')}}
      </div>
    </ul>
    <!-- payment -->
    <Loader v-if="paymentOptionsIsLoading" />
    <div v-if="!paymentOptionsIsLoading" class="quote__method">
      <div class="methodName">{{$t('qic_quote_payment_select')}}</div>
      <div class="quote__method-list">
        <div v-if="shouldDisplayAppleButton" class="quote__method-item">
          <input class="quote__method-radio" name="card" type="radio" id="apple-pay" :value="2" v-model="paymentMethod" @change="onChooseCard(2)">
          <label for="apple-pay">
            <i></i>
            <span>Apple Pay</span>
            <svg width="48" height="28">
              <use xlink:href="../../assets/images/quote/method-sprite.svg#apple"></use>
            </svg>
          </label>
        </div>
        <div v-if="isShowMethod('CC')" class="quote__method-item">
          <input class="quote__method-radio" name="card" type="radio" id="credit-card" :value="0" v-model="paymentMethod" @change="onChooseCard(0)">
          <label for="credit-card">
            <i></i>
            <span>{{$t('qic_quote_payment_bank_card')}}</span>
            <svg width="127" height="20">
              <use xlink:href="../../assets/images/quote/method-sprite.svg#classic"></use>
            </svg>
          </label>
        </div>
        <div v-if="isShowMethod('DC') && (selectedPaymentPlan === paymentPlans[0])" class="quote__method-item">
          <input class="quote__method-radio" name="card" type="radio" id="naps" :value="1" v-model="paymentMethod" @change="onChooseCard(1)">
          <label for="naps">
            <i></i>
            <span>{{$t('qic_quote_payment_naps')}}</span>
            <svg width="48" height="28">
              <use xlink:href="../../assets/images/quote/method-sprite.svg#naps"></use>
            </svg>
          </label>
        </div>
      </div>
    </div>
    <!-- terms -->
    <div v-if="!paymentOptionsIsLoading" class="checkbox-container" :class="{'checkbox-error': acceptanceError}">
      <input type="checkbox" class="checkbox" id="acceptCheck" name="acceptCheck" v-model="acceptance">
      <label for="acceptCheck">
          <span >
            {{ $t('qic_quote_acceptance_before_link') }}
            <a :href="termsHref" target="_blank" @click="$emit('clickTerms')">
              {{ $t('qic_quote_acceptance_link') }}
            </a>
            {{ $t('qic_quote_acceptance_after_link') }}
          </span>
      </label>
    </div>
    <!-- checkout button -->
    <div v-if="!paymentOptionsIsLoading" class="quote__btn-group">
      <BaseButton v-if="paymentMethod !== 2" type="button" class="quote__btn" @click="onSubmit">
        {{$t('qic_quote_checkout_button')}}
      </BaseButton>
      <QuoteApplePayButton
        v-if="isApplePayAvailable"
        :showBtn="paymentMethod === 2"
        :total-price="quoteTotalPrice || 0.0"
        :quote-number="quoteNumber"
        :acceptance="acceptance"
        :getTotalCallBack="getApplePayTotalCallback"
        @succeedPayment="succeedApplePay"
        @start-pay="startApplePay"/>
    </div>
    <div class="quote__agree">{{ $t('qic_quote_payment_acceptance_text') }}
      <a href="#" @click.prevent="onPaymentTermsClick"> {{ $t('qic_quote_payment_acceptance_link') }}</a>
    </div>
    <img src="../../assets/images/pay.svg" class="payImg" alt="pay">
    <SslProtectionReminder />
    <BasePopupWrapper v-if="showPopup" @close="close">
      <TermsPopupDibsy v-if="paymentMethod === 2 || (this.selectedPaymentPlan === 'annual' && paymentMethod === 0)"/>
      <TermsPopup v-else/>
    </BasePopupWrapper>
  </div>
</template>

<script>
import SslProtectionReminder from '../SslProtectionReminder'
import BasePopupWrapper from '../popups/BasePopupWrapper.vue'
import TermsPopup from '../popups/TermsPopup'
import TermsPopupDibsy from '../popups/TermsPopupDibsy'
import QuoteApplePayButton from './QuoteApplePayButton'
import Loader from '../Loader'
import httpClient from '@/plugins/axios'

export default {
  name: 'QuoteCheckout',
  props: {
    termsHref: { type: String },
    quoteInclusivePrice: { type: Number },
    quoteAdditionalPrice: { type: Number },
    quoteTotalPrice: { type: Number },
    prices: { type: Object, default: () => ({ annual: 0, monthly: 0 }) },
    quoteNumber: { type: [String, Number] },
    quoteDiscountOnline: { type: Number, default: 0 },
    totalPriceLoading: { type: Boolean },
    paymentPlanSwitch: { type: Boolean, default: false },
    discountsArray: { type: Array, required: false, default: () => [] },
    promocode: { type: [Number, String] },
    yourQuoteTitle: { type: String },
    getApplePayTotalCallback: {
      type: Function
    }
  },
  emits: [
    'onPayment',
    'chooseCard',
    'onChangePaymentPlan',
    'applePaySucceed',
    'clickTerms',
    'clickPaymentTerms'
  ],
  components: {
    SslProtectionReminder,
    BasePopupWrapper,
    TermsPopup,
    TermsPopupDibsy,
    Loader,
    QuoteApplePayButton
  },
  data () {
    return {
      showPopup: false,
      paymentMethod: 0,
      acceptance: true,
      acceptanceError: false,
      selectedPaymentPlan: 'annual',
      paymentPlans: ['annual', 'monthly'],
      paymentOptions: [],
      paymentOptionsIsLoading: false,
      paymentOptionsIsGot: false,
      selectedCard: null
    }
  },
  computed: {
    isApplePayAvailable () {
      return window?.ApplePaySession && window?.ApplePaySession.canMakePayments()
    },
    yourQuoteTitle_ () {
      return this.yourQuoteTitle || this.$t('qic_quote_checkout_your_quote')
    },
    discountsArrayFiltered () {
      return this.discountsArray.filter(value => Number(value.premium) > 0).sort((a, b) => Number(a) - Number(b))
    },
    oneDiscount () {
      return this.discountsArrayFiltered.length === 1 &&
        (+this.quoteDiscountOnline !== 0 || +this.discountsArrayFiltered[0].premium !== 0)
    },
    priceTitle () {
      if (this.selectedPaymentPlan === this.paymentPlans[0]) return this.$t('qic_quote_checkout_total')
      return this.$t('qic_quote_checkout_monthly_payment')
    },
    getDiscountTitle () {
      if (Array.isArray(this.discountsArrayFiltered) && this.discountsArrayFiltered.length === 1) {
        return this.discountsArrayFiltered[0].name
      }
      return this.$t('qic_quote_checkout_discount')
    },
    shouldDisplayAppleButton () {
      return this.selectedPaymentPlan === 'annual' && this.isApplePayAvailable
    }
  },
  methods: {
    getFixedPrice (value) {
      return Number(value).toFixed(2)
    },
    onPaymentTermsClick () {
      this.showPopup = true
      this.$emit('clickPaymentTerms')
    },
    onSubmit () {
      if (!this.acceptance) {
        this.acceptanceError = true
        return false
      }
      return this.$emit('onPayment', {
        paymentMethod: this.paymentMethod
      })
    },
    onChooseCard (paymentMethod) {
      this.selectedCard = paymentMethod
      const paymentMethods = ['credit-card', 'naps', 'apple-pay']
      const selectedPaymentMethod = paymentMethods[paymentMethod] || ''
      const eventData = {
        paymentMethod: selectedPaymentMethod
      }
      this.$emit('chooseCard', eventData)
    },
    startApplePay () {
      if (!this.acceptance) {
        this.acceptanceError = true
        return false
      }
    },
    openPopup (popup) {
      this.showPopup = true
      const body = document.querySelector('body')
      body.classList.add('overflow-off')
    },
    close () {
      this.$emit('close')
      this.showPopup = false
      const body = document.querySelector('body')
      body.classList.remove('overflow-off')
    },
    succeedApplePay () {
      this.$emit('applePaySucceed')
    },
    // TODO: It mustnt be here
    async getPaymentOptions () {
      if (this.paymentOptionsIsGot || !this.quoteNumber) return
      try {
        this.paymentOptionsIsLoading = true
        const { data } = await httpClient.get(`getpaymentoptions?quoteno=${this.quoteNumber}`)

        if (data?.paymentOptions?.length) {
          this.paymentOptions = data.paymentOptions

          const cc = this.isShowMethod('CC')
          const dc = this.isShowMethod('DC')
          if (this.paymentMethod !== 2) {
            this.paymentMethod = (!cc && dc) ? 1 : 0
          }
          this.paymentOptionsIsGot = true
        } else {
          this.$emit('setQuoteError', true)
        }
      } catch (e) {
        this.$emit('setQuoteError', true)
      } finally {
        this.paymentOptionsIsLoading = false
        const isAvailableApple = window.ApplePaySession && window.ApplePaySession.canMakePayments()
        const isDesiredType = (this.paymentOptions.find(({ paymtType }) => paymtType === 'CC' || paymtType === 'DC') === undefined)
        const error = !this.paymentOptions || (isDesiredType && !isAvailableApple)
        this.$emit('setQuoteError', error)
      }
    },
    isShowMethod (method) {
      return this.paymentOptions?.find(({ paymtType }) => paymtType === method)
    }
  },
  watch: {
    acceptance () {
      this.acceptanceError = false
    },
    selectedPaymentPlan () {
      if (this.selectedPaymentPlan === this.paymentPlans[1]) {
        this.paymentMethod = 0
      }
      this.$emit('onChangePaymentPlan', this.selectedPaymentPlan)
    },
    shouldDisplayAppleButton () {
      if (this.shouldDisplayAppleButton) {
        this.paymentMethod = 2
      }
    },
    quoteTotalPrice () {
      this.getPaymentOptions()
    },
    paymentPlanSwitch () {
      this.selectedPaymentPlan = this.paymentPlans[0]
      this.$emit('onChangePaymentPlan', this.paymentPlans[0])
    }
  },
  async mounted () {
    this.onChooseCard(this.paymentMethod)
    await this.getPaymentOptions()
    if (this.shouldDisplayAppleButton) {
      this.paymentMethod = 2
    }
  }
}
</script>

<style lang="scss">
.switchQuote__container {
  label {
    display: flex;
    flex-direction: column;
  }
}
.without-discount {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-decoration-line: line-through;
  color: rgba(82, 108, 130, 0.8);
  margin: 0 12px;
  @media (max-width: 550px){
    font-size: 14px;
  }
}
.discount {
  span.name, span.price{
    color: #18B97D;
  }
}
span.price, .ltrPrice{
  direction: ltr;
}
.checkbox-error {
  color: red;
}
.footer-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #1C1C1C;
  margin-top: 24px;
}
apple-pay-button {
  --apple-pay-button-max-width: 416px;
  --apple-pay-button-width: 100%;
  --apple-pay-button-height: 80px;
  --apple-pay-button-border-radius: 12px;
  --apple-pay-button-padding: 15px 0px;
  --apple-pay-button-box-sizing: border-box;
}
</style>
